import { Component, Event, EventEmitter, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'tambr-quantity-selector',
  styleUrl: 'tambr-quantity-selector.css',
  shadow: true,
})
export class TambrQuantitySelector {

  @Prop() previousQuantity: number;
  @Prop() maxQuantity: number;

  @State() quantity: number;

  @Event() quantityChange: EventEmitter<number>;

  componentWillLoad() {
    this.quantity = this.previousQuantity || 1;
  }

  increase() {
    if( this.quantity === this.maxQuantity ) return;
    this.quantity++;
    this.quantityChange.emit(this.quantity)
  }

  decrease() {
    if( this.quantity <= 1 ) return;
    this.quantity--;
    this.quantityChange.emit(this.quantity)
  }

  render() {
    return (
      <div class="quantity-selector">
        <button class="quantity-selector-button" disabled={ this.quantity <= 1 } onClick={ () => this.decrease() }>
          <svg class="outline" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>
          <svg class="fill" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"/></svg>
        </button>
        <span class="quantity-selector-value">{ this.quantity }</span>
        <button class="quantity-selector-button" disabled={ this.quantity === this.maxQuantity } onClick={ () => this.increase() }>
          <svg class="outline" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>  
          <svg class="fill" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>
        </button>
      </div>
    );
  }

}
